import { render, staticRenderFns } from "./ProductItemsPartialComponent.html?vue&type=template&id=0a66e3d6&"
import script from "./ProductItemsPartialComponent.js?vue&type=script&lang=js&"
export * from "./ProductItemsPartialComponent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports